import React, { useEffect, useState } from 'react';
//import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import { callFunctionConditionallyWithWarningCurry } from '../../utils/utils';
import styles from './AggrgatesLineDropdownSelectorForMaterial.module.css';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import clsx from 'clsx';
import { DISPLAY_MESSAGES, AGGREGATESMATERIAL } from '../../constants';
import {
  fetchLinesForGivenPlant,
} from "../../apis/calls";

const AggrgatesLineDropdownSelectorForMaterial = ({
  hasActiveEdits,
  isDarkStyle,
  height = 30,
  sequenceAdherenceDashBoard,
  setLineValueForSequenceAdherence,
  plantValue,
}) => {
  const [aggregateLine, setAggregateLine] = usePlantAndLinesStore().aggregateLineState;
 const [line, setLine] = usePlantAndLinesStore().lineState;
  const [plant, setPlant] = usePlantAndLinesStore().plantState;
  const lineOptions = Object.values(AGGREGATESMATERIAL).map(item => ({
    label: item,
    value: item
  }))
  const [shopTypeOptions, setShopTypeOptions] = useState([]);
  const [selectedShopType, setSelectedShopType] = useState(null);
  const [lineNames, setLineNames] = useState({});
  const [selectedLine, setSelectedLine] = useState(null);
  const [data, setData] = useState([]);
  const [LineForSeqAdherence, setLineForSeqAdherence] = useState({
    value: '9000',
    label: 'ALL',
  });

  const handleShopTypeChange = value => {
    setSelectedShopType(value);
    setSelectedLine(null);
    
    const filteredLines = data
      .filter(item => item.shopType === value.label)
      .map(item => ({
        value: item.line,
        label: item.lineName
      }));
    console.log('filteredLines', filteredLines)
    //setLineNames(filteredLines);
    setLineNames(filteredLines.map(type => ({
      label: type.label,
      value: type.value
    })));
  };

  const loadAggregatesLines = async () => {
    const { data: allLines } = await fetchLinesForGivenPlant(plant.value);
    setData(allLines)
    const shopTypes = [...new Set(allLines.map(item => item.shopType))]
    //setShopType(shopTypes);
    setShopTypeOptions(shopTypes.map(type => ({
      label: type,
      value: type
    })));
  }
  const customStyles = {
    control: provided => ({
      ...provided,
      width: 120,
      minWidth: 120,
      height: height,
      minHeight: height,
      fontSize: '12px',
      background: 'none',
      paddingTop: 0,
      paddingBottom: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      width: 120,
      minWidth: 120,
      height: 30,
      minHeight: 30,
      fontSize: '12px',
    }),
    dropdownIndicator: provided => ({
      ...provided,
      width: 30,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    indicatorSeparator: () => ({ display: 'none' }),
  };

  const handleLineChange = valueObject => {
    setLine(valueObject);
    setSelectedLine(valueObject);
  };
  const handleLineChangeForSeqAdherence = value => {
    setLineForSeqAdherence(value);
    setLineValueForSequenceAdherence(value);
  };
  
  const AddAlltoLineOptions = shopType => {
    if (plantValue.label === 'ALL') {
      const lineOptionsForSeqAdherence = [{ value: '9000', label: 'ALL' }];
      return lineOptionsForSeqAdherence;
    } else {
      const lineOptionsForSeqAdherence = shopType.map(record => record);
      lineOptionsForSeqAdherence.unshift({ value: '9000', label: 'ALL' });
      return lineOptionsForSeqAdherence;
    }
  };

  useEffect(() => {
    if (sequenceAdherenceDashBoard) {
      setLineValueForSequenceAdherence('ALL');
    }
    loadAggregatesLines()
  }, [loadAggregatesLines, sequenceAdherenceDashBoard, setLineValueForSequenceAdherence]);

  return(
  <div className={styles.dropdownContainer}>
  <Select
    value={selectedShopType}
    styles={customStyles}
    className={clsx(styles.dropdown, isDarkStyle && styles.dropdownDark)}
    classNamePrefix="select-line"
    onChange={callFunctionConditionallyWithWarningCurry(
        handleShopTypeChange,
        hasActiveEdits,
      )}
    options={shopTypeOptions}
  />
  {/* <div className={styles.selectorSmall}>
           
  </div> */}
   <span className={styles.captionSmall}>Line</span>
  <Select
    value={selectedLine}
    styles={customStyles}
    className={clsx(styles.dropdown, isDarkStyle && styles.dropdownDark)}
    classNamePrefix="select-line"
    onChange={callFunctionConditionallyWithWarningCurry(
      handleLineChange,
      hasActiveEdits,

    )}
    options={lineNames}
  />
</div>
    )
};

AggrgatesLineDropdownSelectorForMaterial.prototypes = {
  hasActiveEdits: PropTypes.bool,
  isDarkStyle: PropTypes.bool,
  height: PropTypes.number,
};
export default AggrgatesLineDropdownSelectorForMaterial;
